import { css } from 'lit';

export const style = css`
  .where-vin-modal-container {
    display: flex;
    justify-content: center;
    margin-bottom: 1em;
  }

  .vin-field {
    margin-bottom: 1em;
  }
`;
